export default __webpack_public_path__ + "static/media/rules.07812e23.webp";